import React from 'react'
import style from './Services.module.scss'
import { useTranslation } from 'react-i18next'

export default function Services() {
    const { t } = useTranslation();
    
    const services = [
        {
            titleKey: 'services.items.chemical.title',
            descriptionKey: 'services.items.chemical.description',
            icon: 'fa-flask'
        },
        {
            titleKey: 'services.items.fibers.title',
            descriptionKey: 'services.items.fibers.description',
            icon: 'fa-shirt'
        },
        {
            titleKey: 'services.items.trade.title',
            descriptionKey: 'services.items.trade.description',
            icon: 'fa-truck-fast'
        },
        {
            titleKey: 'services.items.agricultural.title',
            descriptionKey: 'services.items.agricultural.description',
            icon: 'fa-wheat-awn'
        }
    ]

    return (
        <section id="services" className={style.services}>
            <div className="container">
                <div className={style.title}>
                    <h2>{t('services.title')}</h2>
                    <p>{t('services.subtitle')}</p>
                </div>
                <div className="row">
                    {services.map((service, index) => (
                        <div className="col-lg-6 col-md-6 mb-4" key={index}>
                            <div className={style.serviceCard}>
                                <div className={style.iconWrapper}>
                                    <i className={`fa-solid ${service.icon}`}></i>
                                </div>
                                <div className={style.content}>
                                    <h3>{t(service.titleKey)}</h3>
                                    <p>{t(service.descriptionKey)}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
} 